import React from "react";
import { StyleSheet, View } from "react-native";
import { Ionicons } from "@expo/vector-icons";

import Colors from "../../../Resources/Color";
import Tooltip from "../../Components/Tooltip";

export default function NutritionConflictWarningIcon({
  tooltip = "",
  size = 14,
  style = null,
  placement = "top",
}) {
  if (!tooltip) {
    return null;
  }

  return (
    <Tooltip content={tooltip} placement={placement} rawText={true}>
      <View style={[styles.wrap, style]}>
        <Ionicons
          name="warning-outline"
          size={size}
          color={Colors.warningTextColor}
        />
      </View>
    </Tooltip>
  );
}

const styles = StyleSheet.create({
  wrap: {
    alignItems: "center",
    justifyContent: "center",
  },
});
